<template>
  <centered-box>
    <h3 class="title is-3">{{ $t("Log in with Email") }}</h3>
    <message v-if="error" class="is-danger"> {{ $t(error) }} </message>
    <input-field
      :label="$t('Email')"
      type="text"
      v-model="email"
      @focus="email_onFocus"
      :errors="email_errorsIfTouched"
      :placeholder="$t('Enter your email')"
    />
    <input-field
      :label="$t('Password')"
      type="password"
      v-model="password"
      @focus="password_onFocus"
      :errors="password_errorsIfTouched"
      :placeholder="$t('Enter your password')"
    />
    <button
      class="button is-primary is-fullwidth"
      :disabled="!group_valid"
      @click="loginWithEmail"
    >
      {{ $t("Log in") }}
    </button>
    <div class="has-text-centered is-p1">
      <router-link to="/login">{{ $t("All log in options") }}</router-link>
    </div>
    <div class="has-text-centered is-p1">
      <router-link to="/reset-password">{{
        $t("Forgot password")
      }}</router-link>
    </div>
  </centered-box>
</template>

<script>
import { InputField } from "@/components/form"
import Message from "@/components/message"
import { CenteredBox } from "@/components/layout"
import { actions } from "@/store"
import { validator, email, required, size } from "@/validator"

export default {
  name: "login-email",
  props: ["initialEmail"],
  mixins: [validator],
  components: {
    CenteredBox,
    InputField,
    Message
  },
  data() {
    return {
      email: this.initialEmail,
      password: "",
      error: undefined
    }
  },
  validations: {
    email: [required, email],
    password: [required, size(6, 32)]
  },
  methods: {
    loginWithEmail() {
      this.error = undefined
      actions
        .loginWithEmail(this.email, this.password)
        .then(() => {
          this.$router.push("/")
        })
        .catch(error => {
          this.error = this.getErrorMessage(error)
          this.$logger.error(this.error, error)
        })
    },
    getErrorMessage(error) {
      switch (error.code) {
        case "auth/user-not-found":
          return "user-not-found"
        case "auth/wrong-password":
          return "wrong-password"
        case "auth/network-request-failed":
          return "network-request-failed"
        default:
          return "login-error"
      }
    }
  }
}
</script>
